(function(){var s=document.createElement("style");s.textContent=".wtg-term-link{color:inherit;text-decoration:none;border-bottom:1px dotted #C4A864;cursor:help}\n  .wtg-term-link:hover{color:#12302C;border-bottom-color:#12302C}";document.head.appendChild(s);})();
(function(){
  var LANG=(document.documentElement.getAttribute("lang")||"ja").toLowerCase();
  var LG=LANG.indexOf("ja")===0?"ja":LANG.indexOf("zh")===0?"zh":LANG.indexOf("ko")===0?"ko":"en";
  var EN=LG!=="ja";
  var ROOT=(function(){ try{ var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/"; r=r.replace(/\/+$/,""); return r; }catch(e){ return ({ja:"",en:"/en",zh:"/zh",ko:"/ko"}[LG]||""); } })();
  var PAGE = ROOT + '/pages/watch-glossary';
  var SELECTORS = [
    '.product__description', '.product-single__description', '.product__description.rte',
    '.product-single__content .rte', '[data-product-description]', '.product-form__description',
    '#ProductInfo-template--main .rte', '.product__accordion .rte'
  ].join(',');
  var MAX_LINKS = 14;
  var MIN_LEN   = 3;
  var SKIP = ['保証','相場','定価','買取','希少性','経年変化','保管','針','石','焼け','シミ','ガタ','サビ','ケース','文字盤','風防','素材','コマ','薄型','時針','分針','秒針','棚卸し','回転率','テーパー','キーパー','ステッチ','裏張り','ロゴ','防水','耐磁','希少','個体差','石数'];
  var SKIP_EN = ['Movement','Case','Dial','Hands','Crystal','Strap','Bracelet','Material','Gold','Silver','Steel','Glass','Watch','Brand','Price','Market','Condition','Guarantee','Warranty','Stock','Link','Screw','Spring','Wheel','Plate','Hand','Side','Shape','Size','Line','Star','Type','Rate','Original','Vintage','Antique','Stone','Jewel','Ring','Back','Face','Band','Belt','Pin','Cap','Bar','Set'];

  function esc(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}

  function runJA(){
    var data = window.WT_GLOSSARY_INDEX; if(!data || !data.length) return;
    var roots = document.querySelectorAll(SELECTORS); if(!roots.length) return;
    var terms = data.slice()
                    .filter(function(s){return s.length>=MIN_LEN && SKIP.indexOf(s)<0;})
                    .sort(function(a,b){return b.length-a.length;});
    walkAll(roots, function(text, used){
      var avail = terms.filter(function(t){return !used[t];});
      if(!avail.length) return null;
      var re = new RegExp(avail.map(esc).join('|'));
      var m = re.exec(text);
      if(!m) return null;
      return {index:m.index, term:m[0], key:m[0]};
    });
  }

  function runCJK(data, minlen){
    if(!data || !data.length) return;
    var roots = document.querySelectorAll(SELECTORS); if(!roots.length) return;
    var pairs = data.filter(function(p){return p[0].length>=minlen;});
    var map={}; pairs.forEach(function(p){ map[p[0]]=p[1]; });
    var body = pairs.map(function(p){return esc(p[0]);}).join('|');
    var re;
    try{ re = new RegExp('('+body+')'); }catch(e){ return; }
    walkAll(roots, function(text, used){
      var from=0;
      while(true){
        var seg=text.slice(from);
        var m=re.exec(seg);
        if(!m) return null;
        var word=m[1];
        var at=from+m.index;
        if(!used[word] && map[word]) return {index:at, term:word, key:word, ja:map[word]};
        from=at+word.length;
        if(from>=text.length) return null;
      }
    });
  }

  function runEN(){
    var data = window.WT_GLOSSARY_INDEX_EN; if(!data || !data.length) return;
    var roots = document.querySelectorAll(SELECTORS); if(!roots.length) return;
    var pairs = data.filter(function(p){return p[0].length>=4 && SKIP_EN.indexOf(p[0])<0;});
    var map={}; pairs.forEach(function(p){ map[p[0].toLowerCase()]=p[1]; });
    var body = pairs.map(function(p){return esc(p[0]);}).join('|');
    walkAll(roots, function(text, used){
      var re;
      try{ re = new RegExp('(^|[^A-Za-z0-9])('+body+')([^A-Za-z0-9]|$)','i'); }catch(e){ return null; }
      var from=0;
      while(true){
        var seg=text.slice(from);
        var m=re.exec(seg);
        if(!m) return null;
        var word=m[2];
        var at=from+m.index+m[1].length;
        var lc=word.toLowerCase();
        if(!used[lc] && map[lc]) return {index:at, term:word, key:lc, ja:map[lc]};
        from=at+word.length;
        if(from>=text.length) return null;
      }
    });
  }

  function walkAll(roots, find){
    var used = {}, count = 0;
    Array.prototype.forEach.call(roots, function(root){
      if(root.getAttribute('data-wtg-done')) return;
      root.setAttribute('data-wtg-done','1');
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode:function(n){
          if(!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          while(p && p !== root){
            var tag = p.nodeName;
            if(tag==='A'||tag==='SCRIPT'||tag==='STYLE'||tag==='CODE'||tag==='BUTTON'||/^H[1-3]$/.test(tag)) return NodeFilter.FILTER_REJECT;
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var queue=[], n; while((n=walker.nextNode())) queue.push(n);
      while(queue.length && count < MAX_LINKS){
        var node = queue.shift();
        var r = find(node.nodeValue, used);
        if(!r) continue;
        var after = node.splitText(r.index);
        after.nodeValue = after.nodeValue.slice(r.term.length);
        var a = document.createElement('a');
        a.className = 'wtg-term-link';
        a.href = PAGE + '?term=' + encodeURIComponent(r.ja || r.term);
        a.title = LG==='ja' ? (r.term + ' の意味を見る') : LG==='zh' ? ('查看「' + r.term + '」的释义') : LG==='ko' ? (r.term + ' 의 뜻 보기') : ('See the meaning of ' + r.term);
        a.textContent = r.term;
        node.parentNode.insertBefore(a, after);
        used[r.key] = 1; count++;
        queue.unshift(after);
      }
    });
  }

  function run(){
    if(LG==='ja') runJA();
    else if(LG==='zh') runCJK(window.WT_GLOSSARY_INDEX_ZH, 2);
    else if(LG==='ko') runCJK(window.WT_GLOSSARY_INDEX_KO, 3);
    else runEN();
  }
  function boot(){ if(window.WT_GLOSSARY_INDEX || window.WT_GLOSSARY_INDEX_EN || window.WT_GLOSSARY_INDEX_ZH || window.WT_GLOSSARY_INDEX_KO){ run(); } else { setTimeout(boot,150); } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load', function(){ setTimeout(run,60); });
})();
